import {
  SidebarBodyLegacy,
  SidebarHeaderLegacy,
  SidebarLegacy,
  TimelineLegacy,
  TTimelineItemLegacyType,
} from '@commenda/kakashi';
import { IncorporationRequestStatus } from '@prisma/client';
import Logo from './Logo';

const IncorporationFormSidebar = ({
  steps,
  setActiveStep,
  status,
}: {
  steps: TTimelineItemLegacyType[];
  setActiveStep: (idx: number) => void;
  status?: IncorporationRequestStatus;
}) => {
  return (
    <SidebarLegacy className="bg-violet-3">
      <SidebarHeaderLegacy className="border-b border-b-stroke-2">
        <Logo />
      </SidebarHeaderLegacy>
      <SidebarBodyLegacy className="p-6 mt-0">
        <TimelineLegacy
          steps={steps}
          setActiveStep={setActiveStep}
          forceDisable={
            status !== IncorporationRequestStatus.NotStarted &&
            status !== IncorporationRequestStatus.InProgress
          }
        />
      </SidebarBodyLegacy>
    </SidebarLegacy>
  );
};

export default IncorporationFormSidebar;
